import { Fragment } from "react";
import { Grid as MuiGrid } from "@mui/material";

import { StyledAvatar } from "@framework/styled";
import type { IMerchant } from "@framework/types";
import { emptyStateString } from "@dzambalaorg/draft-js-utils";
import { Breadcrumbs, PageHeader, Spinner } from "@dzambalaorg/mui-page-layout";
import { RichTextDisplay } from "@dzambalaorg/mui-rte";
import { useFetchData } from "@dzambalaorg/react-hooks";
import { Typography } from "@dzambalaorg/ui-kit";

import { ContractList } from "../contract-list";

export const Merchant = () => {
  const {
    data: selected = {
      title: "",
      description: emptyStateString,
    } as IMerchant,
    isLoading,
  } = useFetchData<IMerchant>(`/merchants`); // We don't use the id because it's embedded in the hook request.

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "marketplace", "marketplace.merchant"]} data={[{}, {}, selected]} />

      <PageHeader message="pages.marketplace.merchant.title" data={selected} />

      <MuiGrid container size={12} mt={1} mb={5}>
        <MuiGrid size={3}>
          <StyledAvatar src={selected.imageUrl} />
        </MuiGrid>
        <MuiGrid size={9}>
          <Typography variant="body2" color="textSecondary" component="div">
            <RichTextDisplay data={selected.description} />
          </Typography>
        </MuiGrid>
      </MuiGrid>

      <ContractList embedded />
    </Fragment>
  );
};
